const SupportedImageExtensions = '.jpg,.jpeg,.png,.jfif';

export default SupportedImageExtensions;
